/**
 *
 * Points
 *
 */

import { mapGetters } from 'vuex';

export default {
  name: 'PointsChanges',

  computed: {
    ...mapGetters('Points', {
      mg_pointsChanges: 'pointsChanges',
    }),
  },

  filters: {
    fmtPointsPlus: (v) => (v ? '+' + v : 0),

    fmtPointsMinus: (v) => (v ? v : 0),
  },
};
